import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './BlogPage.css';

const BlogPage = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await api.getPosts();
                if (response && response.data) {
                    setPosts(response.data);
                    setError(null);
                }
            } catch (error) {
                console.error('Error fetching posts:', error);
                setError('Failed to load posts');
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    if (loading) return <div className="blog-container">Loading...</div>;
    if (error) return (
        <div className="blog-container">
            <div className="error-message">
                {error}
                <button onClick={() => window.location.reload()}>Try again</button>
            </div>
        </div>
    );

    return (
        <div className="blog-container">
            <header className="blog-header">
                <h1><Link to="/">Sercihan's</Link></h1>
            </header>
            
            <div className="blog-content">
                <h2>Essays</h2>
                
                {posts.length === 0 ? (
                    <div className="no-posts">No posts found</div>
                ) : (
                    <div className="posts-list">
                        {posts.map(post => (
                            <div key={post.id} className="post-item">
                                <div className="post-info">
                                    <Link to={`/post/${post.slug}`} className="post-title">
                                        {post.title}
                                    </Link>
                                    <span className="post-date">
                                        {new Date(post.created_at).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        })}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BlogPage;
